import { PageTabs } from "@/components/ui/page-tabs";
import { useState } from "react";
import { SuspensionsDetail } from "./components/SuspensionsDetail";

type SuspensionsPageTabs = "detalles";

const suspensionsPageTabs = [{ label: "Detalles", key: "detalles" }];

const SuspensionsPage = () => {
  const [activeTab, setActiveTab] = useState<SuspensionsPageTabs>("detalles");

  return (
    <div className="w-full flex flex-col">
      {/* Tabs */}
      <PageTabs
        tabs={suspensionsPageTabs}
        activeKey={activeTab}
        onTabChange={(key) => {
          setActiveTab(key as SuspensionsPageTabs);
        }}
      />

      {activeTab === "detalles" ? <SuspensionsDetail /> : <></>}
    </div>
  );
};

export default SuspensionsPage;
